import { AvatarProps } from './types';
import { TypographyProps } from '../Typography';


interface PropsBySize {
    width: number;
    borderRadius: number;
    iconSize: number;
}

export const AvatarPropsBySize: Record<AvatarProps['size'], PropsBySize> = {
    XL: {
        width: 17,
        borderRadius: 6,
        iconSize: 8,
    },
    L: {
        width: 14,
        borderRadius: 5,
        iconSize: 6,
    },
    M: {
        width: 12,
        borderRadius: 4,
        iconSize: 6,
    },
    S: {
        width: 10,
        borderRadius: 3,
        iconSize: 5,
    },
};

export const TypographyVariantBySize: Record<AvatarProps['size'], TypographyProps['variant']> = {
    XL: 'mediumHeader1',
    L: 'mediumBody1',
    M: 'mediumBody2',
    S: 'mediumCaption1',
};
